import { useEffect } from "react"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastTitle,
} from "./toast"
import { useToast } from "./use-toast"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  useEffect(() => {
    const timers = []
    toasts.forEach((toast) => {
      if (toast.open) {
        const timer = setTimeout(() => {
          dismiss(toast.id)
        }, 3000)
        timers.push(timer)
      }
    })
    return () => timers.forEach(clearTimeout)
  }, [toasts, dismiss])

  return (
    <div className="fixed top-0 z-[9999] flex max-h-screen w-full flex-col-reverse p-4 sm:right-0 sm:top-0 sm:flex-col md:max-w-[420px]">
      {toasts
        .filter((toast) => toast.open)
        .map(function ({ id, title, description, action, ...props }) {
          return (
            <Toast key={id} {...props}>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose onClick={() => dismiss(id)} />
            </Toast>
          )
        })}
    </div>
  )
}
